import React from 'react';

import LogoPng from './logo.png';

export const Logo = (props: React.ImgHTMLAttributes<HTMLImageElement>) => {
    return <img width="24.64px" height="34.12px" src={LogoPng} alt="logo" {...props} />;
};
